import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewUserData } = appStoreLenses

export default state => viewUserData(state) || {}
